// Utils
import { component } from 'picoapp';

import { setCSSProperty } from 'utils/css';

import choozy from 'utils/choozy';

export default component((node) => {
  const { inner } = choozy(node);

  // Options
  const zoomOnHover = node.dataset.zoomOnHover === 'true';

  const MAX_ZOOM = 2;
  const PADDING = 0.75;

  let zoomedIn = false;
  let mouseEntered = false;

  const innerBox = {};

  const defineBox = () => {
    const { left, top, width, height } = inner.getBoundingClientRect();

    const boxWidth = width * PADDING;
    const boxHeight = height * PADDING;

    const paddingX = (width - boxWidth) / 2;
    const paddingY = (height - boxHeight) / 2;

    innerBox.left = left + paddingX;
    innerBox.top = top + paddingY;
    innerBox.width = boxWidth;
    innerBox.height = boxHeight;
  };

  const updateZoomPosition = (e) => {
    if (zoomedIn === false) return;

    const { clientX, clientY } = e;

    const x = 100 * Math.min(1, Math.max(0, clientX - innerBox.left) / innerBox.width);
    const y = 100 * Math.min(1, Math.max(0, clientY - innerBox.top) / innerBox.height);

    setCSSProperty(inner, '--zoom-origin', `${x}% ${y}%`);
  };

  const emitZoomEvent = () => {
    const event = new CustomEvent(zoomedIn ? 'zoom:start' : 'zoom:end', {
      bubbles: true,
      cancelable: true,
    });

    node.dispatchEvent(event);
  };

  const toggleZoom = (e, setZoom = null) => {
    if (window.innerWidth < 1024) return;

    zoomedIn = setZoom === null ? !zoomedIn : setZoom;

    defineBox();
    if (zoomOnHover === false) emitZoomEvent();

    setCSSProperty(inner, '--zoom-level', zoomedIn ? MAX_ZOOM : 1);

    if (!zoomedIn) return;

    updateZoomPosition(e);
  };

  if (zoomOnHover) {
    inner.addEventListener('mouseenter', (e) => {
      mouseEntered = true;

      if (!zoomedIn) toggleZoom(e);
    });

    inner.addEventListener('mouseleave', (e) => {
      mouseEntered = false;

      if (zoomedIn) toggleZoom(e);
    });

    inner.addEventListener('slider:touchEnd', (e) => {
      if (mouseEntered) toggleZoom(e.detail, true);
    });

    inner.addEventListener('slider:touchStart', (e) => {
      toggleZoom(e.detail, false);
    });
  } else {
    inner.addEventListener('click', toggleZoom);
  }

  node.addEventListener('mousemove', updateZoomPosition);

  const handleViewResize = ({ isMobile } = window.theme) => {
    if (document.fullscreenElement || !isMobile) return;

    const { scale } = window.visualViewport;

    zoomedIn = scale > 1;
    emitZoomEvent();
  };

  document.addEventListener('theme:screen:size-updated', handleViewResize);
});
